import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import { ReplyRecUnsuccessfulReason } from './ReplyRecUnsuccessfulReason';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapLink = props => /*#__PURE__*/_jsx("span", {
  style: {
    whiteSpace: 'nowrap',
    display: 'inline-block'
  },
  children: /*#__PURE__*/_jsx(Link, Object.assign({}, props))
});
export const DisabledTooltipMessage = ({
  hasReplyRecsEnabled,
  unsuccessfulReason,
  hasCustomerAgent
}) => {
  const replyRecsSettingsUrl = `${getFullUrl('app')}/customer-agent/${PortalIdParser.get()}/manage/reply-recommendations`;
  const customerAgentSettingsUrl = `${getFullUrl('app')}/customer-agent/${PortalIdParser.get()}`;
  if (!hasCustomerAgent && !hasReplyRecsEnabled) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.disabledCustomerAgent_jsx',
      elements: {
        Link: NoWrapLink
      },
      options: {
        href: customerAgentSettingsUrl,
        external: true,
        onClick: e => {
          e.stopPropagation();
        }
      }
    });
  }
  if (!hasReplyRecsEnabled) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.replyRecommendations.generationMessages.disabledReplyRecs_jsx',
      elements: {
        Link: NoWrapLink
      },
      options: {
        href: replyRecsSettingsUrl,
        external: true,
        onClick: e => {
          e.stopPropagation();
        }
      }
    });
  }
  return /*#__PURE__*/_jsx(ReplyRecUnsuccessfulReason, {
    unsuccessfulReason: unsuccessfulReason
  });
};